import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {default as ExcelFile, ExcelSheet ,ExcelColumn} from "react-data-export"
import React , {Component} from 'react';
import firebase from'firebase';


const database=firebase.database();


class DetalleViajesEmpresas extends Component{
	
	constructor(props){
		
		super(props)
		this.state={
			clientes:[],
			viajes:[],
			empleados:[],
			viajestemp:[],
			input_disabled:'disabled',
			fecha_actual:'',
			fecha_minima:''
				
			
		}
		
		this.clientesRef=database.ref().child('Clientes').orderByChild('socio').equalTo(this.props.match.params.empresa);
		this.empleadosRef=database.ref().child('Empleados');
		this.viajesRef=database.ref().child('Viaje');
		
		
		this.handleChangeDatePicker1=this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2=this.handleChangeDatePicker2.bind(this);
		this.mostrarRegistrosHoy=this.mostrarRegistrosHoy.bind(this);
		
		
		let f=new Date();
		
		this.state.fecha_actual=f.getFullYear()+'-'+((f.getMonth()+1)>10 ? f.getMonth:'0'+(f.getMonth()+1))+'-'+(f.getDate()>10?f.getDate():'0'+f.getDate());
		
		
	}
	
	
	componentDidMount(){
		
		this.empleadosRef.on('value',this.gotDataEmpleados,this.errDataEmpleados);
		this.clientesRef.on('value',this.gotDataClientes,this.errDataClientes);
		this.viajesRef.on('value',this.gotDataViajes,this.errDataViajes);
		
	}
	
	
	componentWillMount(){
		
		
		this.empleadosRef.on('value',this.gotDataEmpleados,this.errDataEmpleados);
		this.clientesRef.on('value',this.gotDataClientes,this.errDataClientes);
		this.viajesRef.on('value',this.gotDataViajes,this.errDataViajes);
		
	}
	

	gotDataEmpleados=(data)=>{
		
		
		let newEmpleados=[]
		
		if(data.val()!==null){
			
			let dataEmpleados=data.val();
			let keys=Object.keys(dataEmpleados);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				newEmpleados.push({
					key:k,
					nombre:dataEmpleados[k].nombre
				});
			}
			this.setState({empleados:newEmpleados})
			
		}
		
	}
	errDataEmpleados=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataClientes=(data)=>{
		
		let newEmpleados=[]		
		if(data.val()!==null){
		
			let dataEmpleados=data.val();
			let keys=Object.keys(dataEmpleados);
			
			for(let i=0;i<keys.length;i++)
			{
				let k=keys[i]
				
				newEmpleados.push({
					key:k,
					nombre:dataEmpleados[k].nombre,
					apellido:dataEmpleados[k].apellido			
				})
			}
			this.setState({clientes:newEmpleados})
		}
	}
	errDataClientes=(err)=>{
		
		
		console.log(err);
		
	}
	
	gotDataViajes=(data)=>{
		
		let newViajes=[];
		
		if(data.val()!==null){
			
			
			let dataViajes=data.val();
			let keys=Object.keys(dataViajes);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i]
				
				
				let cliente=this.state.clientes.find(clientes=>clientes.key===dataViajes[k].cliente);
				
				
				if(cliente!==undefined){
					
						let empleado=this.state.empleados.find(empleados=>empleados.key===dataViajes[k].empleado);
					
						newViajes.push({
							key:k,
							cliente:cliente.nombre+' '+cliente.apellido,
							direccion:dataViajes[k].direccion,
							distancia:dataViajes[k].distancia,
							empleado:(empleado!==undefined)?empleado.nombre:'',
							fechaReserva:(dataViajes[k].fechaReserva!==undefined)?dataViajes[k].fechaReserva.substring(0,10):"",
							fechaSubida:(dataViajes[k].fechaSubida!==undefined)?dataViajes[k].fechaSubida.substring(0,10):"",
							fechaBajada:(dataViajes[k].fechaBajada!==undefined)?dataViajes[k].fechaBajada.substring(0,10):"",
							horaSubida:dataViajes[k].fechaSubida.substring(11,16),
							horaBajada:dataViajes[k].fechaBajada.substring(11,16),
							lugar:dataViajes[k].lugar,
							pago:dataViajes[k].pago,
							total:'$'+ parseFloat(dataViajes[k].total)
					
						})
				}
				
			}
			this.setState({viajes:newViajes,viajestemp:newViajes});
			
		}
		
	}
	errDataViajes=(err)=>{
		
		console.log(err);
		
	}
	
	handleChangeDatePicker1(){
		
		let fecha1=this.fecha1.value;
		
		
		this.fecha2.value="";
		
		this.setState({
			
			fecha_minima:fecha1,
			input_disabled:''
		})
		
	}
	
	handleChangeDatePicker2(){
		
		let fecha1=this.fecha1. value;
		let fecha2=this.fecha2.value;
		
		
		let f1=new Date(fecha1);
		let f2=new Date(fecha2);
		
		
		let newViajes=[]

		this.state.viajes=this.state.viajestemp;
		this.setState({
			
			viajes:this.state.viajestemp
		})
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			
			if(f1.getTime()<=(new Date(this.state.viajes[i].fechaBajada)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaBajada))  ||  f1.getTime()<=(new Date(this.state.viajes[i].fechaSubida)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaSubida)) ){
				
				
				
				newViajes.push({
					key:this.state.viajes[i].key,
					cliente:this.state.viajes[i].cliente,
					empleado:this.state.viajes[i].empleado,
					direccion:this.state.viajes[i].direccion,
					fechaReserva:this.state.viajes[i].fechaReserva,
					fechaBajada:this.state.viajes[i].fechaBajada,
					fechaSubida:this.state.viajes[i].fechaSubida,
					horaSubida:this.state.viajes[i].horaSubida,
					horaBajada:this.state.viajes[i].horaBajada,
					pago:this.state.viajes[i].pago,
					total:this.state.viajes[i].total,
					lugar:this.state.viajes[i].lugar
					
					
				})
				
			}
			
		}
		this.setState({
			
			viajes:newViajes
			
		})
		
		
		
		
				
	}
	
	mostrarRegistrosHoy(){
		
		
		let f1=new Date(this.state.fecha_actual);
		let f2=new Date(this.state.fecha_actual);
		
		
		let newViajes=[]

		this.state.viajes=this.state.viajestemp;
		this.setState({
			
			viajes:this.state.viajestemp
		})
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			
			if(f1.getTime()<=(new Date(this.state.viajes[i].fechaBajada)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaBajada))  ||  f1.getTime()<=(new Date(this.state.viajes[i].fechaSubida)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaSubida)) ){
				
				newViajes.push({
					key:this.state.viajes[i].key,
					cliente:this.state.viajes[i].cliente,
					direccion:this.state.viajes[i].direccion,
					empleado:this.state.viajes[i].empleado,
					fechaReserva:this.state.viajes[i].fechaReserva,
					fechaBajada:this.state.viajes[i].fechaBajada,
					fechaSubida:this.state.viajes[i].fechaSubida,
					horaSubida:this.state.viajes[i].horaSubida,
					horaBajada:this.state.viajes[i].horaBajada,
					pago:this.state.viajes[i].pago,
					total:this.state.viajes[i].total,
					lugar:this.state.viajes[i].lugar
					
					
				})
				
			}
			
		}
		this.setState({
			
			viajes:newViajes
			
		})
		
		
		
	}
	
	
	
	
	render(){
		
		return(
			
				<div className="viajes_empledos_empresas">
				

					<div className="container">
				
				
						<div className="row">
							<div className="col-md-3">									
								<ExcelFile  filename="Reporte_Viajes.xlsx" element={(<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>)}>				
									<ExcelSheet data={this.state.viajes} name="Viajes">
											<ExcelColumn label="Cliente" value="cliente" />										
											<ExcelColumn label="Empleado" value="empleado" />										
											<ExcelColumn label="Dirección" value="direccion" />										
											<ExcelColumn label="Distancia en km" value="distancia" />										
											<ExcelColumn label="Fecha Bajada" value="fechaBajada" />										
											<ExcelColumn label="Hora Bajada" value="horaBajada" />										
											<ExcelColumn label="Fecha Subida" value="fechaSubida" />										
											<ExcelColumn label="Hora Subida" value="horaSubida" />										
											<ExcelColumn label="Pago" value="pago" />										
											<ExcelColumn label="Destino" value="lugar" />																				
											<ExcelColumn label="Total" value="total" />																				
									</ExcelSheet>						
								</ExcelFile>
							</div>
							<div className="col-md-3 col-xs-6">	
								<div className="form-group">
									<label htmlFor=" fecha1">Fecha Inicio</label>
									<input type="date" name="fecha1" className="form-control" onChange={this.handleChangeDatePicker1}
									max={ this.state.fecha_actual} ref={input=>{this.fecha1=input}}
									/>
								</div>
							</div>
							<div className="col-md-3 col-xs-6">
								<div className="form-group">
									<label htmlFor="fecha2">Fecha Final</label>
									<input type="date" name="fecha2" className="form-control" disabled={this.state.input_disabled} 
									onChange={this.handleChangeDatePicker2}	max={this.state.fecha_actual} ref={input=>{this.fecha2=input}}
									/>
								</div>
							</div>
							<div className="col-md-3">
								<button type="button" className="btn btn-primary btn-sm" onClick={this.mostrarRegistrosHoy}>Registros de hoy</button>
							</div>
							
						</div>
			 

				
				
					  <BootstrapTable data={ this.state.viajes}
						 ref='table'			 
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataField='cliente' dataSort={true}>Cliente</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataField='empleado' dataSort={true}>Empleado</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'260'} dataField='direccion' dataSort={true}>Dirección</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataField='distancia'>Distancia</TableHeaderColumn>
						 
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='fechaBajada'>Fecha Bajada</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='horaBajada'>Hora Bajada</TableHeaderColumn>						 
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='fechaSubida'>Fecha Subida</TableHeaderColumn>
						 <TableHeaderColumn  width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='horaSubida'>Hora Subida</TableHeaderColumn>
						 
						 
						 <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='pago'>Pago</TableHeaderColumn>
						 <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='lugar'>Lugar</TableHeaderColumn>
						 <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataAlign="center" dataField='total'>Total</TableHeaderColumn>
												 
					  </BootstrapTable>
					</div>

				</div>
		
		
		
		)
		
	}
	
}

export default DetalleViajesEmpresas;



// WEBPACK FOOTER //
// ./src/Components/ViajesEmpresas/DetalleViajesEmpresas.js